import React from "react";
import PropTypes from "prop-types";

import StandardHeader from "./StandardHeader";
import HorizontalHeader from "./HorizontalHeader";
import ComponentMissing from "../../Debug/ComponentMissing";

const Header = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  cols,
  alignment,
  colProportions,
  viewportHeight,
  mirrored,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    cols,
    alignment,
    colProportions,
    viewportHeight,
    mirrored,
    animation,
  };

  function switchHeader() {
    switch (layout) {
      case "standard":
        return <StandardHeader properties={properties} />;
      case "horizontal":
        return <HorizontalHeader properties={properties} />;
      default:
        return <ComponentMissing type="Header" subType={layout} />;
    }
  }

  return switchHeader();
};

Header.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  cols: PropTypes.string,
  alignment: PropTypes.string,
  colProportions: PropTypes.string,
  viewportHeight: PropTypes.bool,
  mirrored: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  animation: PropTypes.instanceOf(Object),
};

export default Header;
